<template>
  <div id="" class="">
      <el-dialog title="创建大类" :visible.sync="isShowdialog" append-to-body :before-close="cancel" width="30%">
        <el-form ref="form" label-width="110px" size="mini" >
          <el-row style="display: flex;justify-content: center">
            <el-col :span="20">
              <el-form-item label="大类名称">
                <el-input v-model="couponForm.categoryName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="display:flex;justify-content: flex-end">
            <el-form-item size="mini">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible','categoryId'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
  },
  data() {
    return {
      isShowdialog: false,
      dialogTitle: '',
      returnTime: '',
      uploading: '',
      audit: '',
      couponForm: {
        categoryName: '',
      }
    }
  },
  methods:{
    cancel(done){
      console.log('category close')
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowdialog,dialog:'coupon'})
    },
    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });

      try{
        if(this.categoryId) this.couponForm.id = this.categoryId
        const coupon = await this.$request.set_message('categories',this.couponForm);
        if(coupon.code === 0){
          this.$message('操作成功');
        }else{
          this.$message(coupon['errMsg']);
        }
      } catch(e) {
        this.$message(e);
      } finally {
        this.uploading.close();
        this.isShowdialog = false;
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'category',refresh:true})
      }
    },

  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/CreateCategoryDialog.vue